import React from "react";
import { BasicInfo } from "../types";

interface ContactSectionProps {
  basics: BasicInfo;
}

const ContactSection: React.FC<ContactSectionProps> = ({ basics }) => {
  return (
    <section className="contact-section section-padding" id="contact">
      <div className="container">
        <div className="row">
          <div className="col-lg-8 col-md-10 col-12 mx-auto">
            <div className="section-header text-center mb-5">
              <h2 className="section-title">Get In Touch</h2>
              <p className="section-subtitle">
                Feel free to reach out for collaborations, opportunities, or
                just to say hello
              </p>
            </div>
            <div className="contact-grid">
              <div className="contact-item">
                <div className="contact-icon">
                  <i className="fas fa-envelope"></i>
                </div>
                <div className="contact-content">
                  <h3>Email</h3>
                  <p>{basics.email}</p>
                </div>
              </div>

              <div className="contact-item">
                <div className="contact-icon">
                  <i className="fas fa-phone"></i>
                </div>
                <div className="contact-content">
                  <h3>Phone</h3>
                  <p>{basics.phone}</p>
                </div>
              </div>

              <div className="contact-item">
                <div className="contact-icon">
                  <i className="fas fa-map-marker-alt"></i>
                </div>
                <div className="contact-content">
                  <h3>Location</h3>
                  <p>{basics.location.address}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ContactSection;
